import React from 'react';
import styles from './style.module.css';

export default ({
    title = 'Back to Calculators',
    path = window.location.pathname.includes('calculators') ? '/calculators/' : '/'
} = {}) => {
    return (
        <div className={`${styles.container} ${styles['back-to-calculators']}`}>
            <a
                href={path}
                title={title}
            >{title}</a>
        </div>
    );
}
